$analytics-mobile-max: 767px;
$analytics-tablet-max: 991px;

.popover {
  &.analytics-score-card-popover {
    .popover-main {
      max-width: 25rem;
    }
  }
}

// // Force single-column layout below @ir/ui lg breakpoint (992px)
// .analytics-dashboard {
//   @media (max-width: $analytics-tablet-max) {
//     .col {
//       flex: 0 0 100% !important;
//       max-width: 100% !important;
//     }
//   }
// }

// // Share page shell
// .share-link-layout-header {
//   @media (max-width: $analytics-tablet-max) {
//     flex-direction: column;
//     align-items: flex-start;
//     gap: var(--spacing-1);
//   }
// }

// .share-link-layout-expiry {
//   @media (max-width: $analytics-tablet-max) {
//     font-size: 0.75rem;
//   }
// }

// .shared-analytics-filter-bar {
//   @media (max-width: $analytics-tablet-max) {
//     padding-left: var(--spacing-2) !important;
//     padding-right: var(--spacing-2) !important;
//   }
// }

// .shared-analytics-content {
//   @media (max-width: $analytics-tablet-max) {
//     padding: var(--spacing-2) !important;
//   }
// }

// // KPI card headers — stack title and toggles on mobile/tablet
// .analytics-kpi-card-header {
//   @media (max-width: $analytics-tablet-max) {
//     flex-direction: column !important;
//     align-items: flex-start !important;
//     gap: var(--spacing-2);
//   }
// }

// Scrollable table wrapper
.analytics-table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;

  @media (max-width: $analytics-tablet-max) {
    .table {
      min-width: 420px;
    }
  }
}

// Pie + legend composites — stack vertically on mobile/tablet
.analytics-pie-composite {
  @media (max-width: $analytics-tablet-max) {
    flex-direction: column !important;
    align-items: stretch !important;

    > :first-child,
    > :last-child {
      flex: none !important;
      max-width: 100% !important;
      min-width: 0 !important;
      width: 100%;
    }
  }
}

// Dispute pipeline summary stats — stack on mobile/tablet
.analytics-dispute-summary {
  @media (max-width: $analytics-tablet-max) {
    flex-direction: row !important;
  }
}

// Chart container height overrides on mobile/tablet
.analytics-chart-content {
  @media (max-width: $analytics-tablet-max) {
    height: 280px !important;
    min-height: 280px !important;
  }
}

.analytics-chart-content--volume {
  @media (max-width: $analytics-tablet-max) {
    min-height: 300px !important;
  }
}

// Card footer chips
.analytics-card-footer {
  flex-wrap: wrap;
}

// .analytics-filter-readonly {
//   @media (max-width: 991px) {
//     flex-direction: column;
//     align-items: flex-start;
//     gap: 1.5rem;
//   }

//   &-brand {
//     @media (max-width: 991px) {
//       flex-wrap: wrap;
//       margin-right: 0 !important;
//       margin-bottom: 0.5rem;
//     }
//   }

//   &-label {
//     font: inherit;
//   }

//   &-value {
//     font: inherit;

//     @media (max-width: 991px) {
//       word-break: break-word;
//     }
//   }

//   &-item {
//     @media (max-width: 991px) {
//       flex-direction: column;
//       align-items: flex-start;
//       width: 100%;
//     }
//   }

//   &-purchaser-value {
//     @media (max-width: 991px) {
//       display: -webkit-box;
//       -webkit-line-clamp: 2;
//       -webkit-box-orient: vertical;
//       overflow: hidden;
//     }
//   }
// }
